// @ts-nocheck
import moment from 'moment-timezone';

import type { NewRoute } from '@cobliteam/api-lib/src/dashboard/routing/Definitions/Types';

export const exportedRoutesSpreadSheetName = (routes: NewRoute[]) => {
  const date = moment(routes[0].startTime).format('YYYYMMDD');
  return `${routes.length === 1 ? routes[0].name : 'rotas'}_${date}.xlsx`.toLocaleLowerCase().replace(/\s/g, '_');
};

export const downloadReportFile = (blob: Blob, name: string, startInMillis: number, endInMillis: number): void => {
  const startTimeStr = moment(startInMillis).format('YYMMDD');
  const endTimeStr = moment(endInMillis).format('YYMMDD');
  const periodStr = startTimeStr === endTimeStr ? startTimeStr : `${startTimeStr}_${endTimeStr}`;

  const filename = `${name}_${periodStr}.xlsx`;
  saveAs(blob, filename);
};

export const downloadRouteSpreadSheetFile = (blob: Blob, route: NewRoute) => {
  saveAs(blob, `${route.name}.xlsx`.toLocaleLowerCase().replace(/\s/g, '_'));
};
